import { Component } from '@angular/core';

@Component({
    selector: 'ct-edit-button',
    templateUrl: 'edit-button.component.html',
    styleUrls: ['edit-button.component.less'],
})
export class EditButtonComponent {
}
